<script>
import * as Filters from '@/filters'

export default {
  props: {
    value: Object,
  },
  computed: {
    properties() {
      return this.$store.state.enums.ResidentialProperties
    },
    filter() {
      return JSON.parse(this.value.data.filter).map(k => {
        const [key, value] = k.split(':')

        return {
          label: this.$t(key),
          key,
          value,
          formatted: this.format(key, value),
        }
      })
    },
  },
  methods: {
    format(key, value) {
      const property = this.properties.find(p => p.key === key)
      const FloatPattern = '[+-]?([0-9]+\\.?[0-9]*|\\.[0-9]+)'

      // GTE / LTE
      if (new RegExp(`^${FloatPattern}[-+]{1}$`).test(value)) {
        return `${value.endsWith('+') ? '>' : '<'} ${Filters.Number(parseFloat(value))}`
      }
      // Range
      if (new RegExp(`^${FloatPattern}-${FloatPattern}$`).test(value)) {
        return value
          .split('-')
          .map(v => Filters.Number(parseFloat(v)))
          .join(' - ')
      }
      // Number
      if (new RegExp(`^${FloatPattern}$`).test(value)) {
        return Filters.Number(parseFloat(value))
      }
      // // Boolean
      if ([true, false, 'true', 'false'].includes(value)) return this.$t([true, 'true'].includes(value) ? 'yes' : 'no')
      // // Select
      if (value.includes(',')) return value.split(',').join(', ')
      // // Default
      if (property && property.unit === 'Enum') return this.$tc([key, value].join(':'), 2)
      return value
    },
  },
}
</script>

<template>
  <div>
    <div>{{ $t('analytics:filter:residentials') }}</div>
    <div data-part="details">
      <template v-for="f in filter">
        <div>{{ f.label }}:</div>
        <div data-part="value">{{ f.formatted }}</div>
      </template>
    </div>
  </div>
</template>

<style lang="scss">
.lead-activities__message[data-event='analytics:filter:residentials'] {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  [data-part='details'] {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 0 0.5rem;

    font-size: 0.8em;
  }

  [data-part='value'] {
    font-weight: bold;
  }
}
</style>
